import React from "react";
import { Stack, Typography } from "@mui/material";
import moment, { Moment } from "moment";
import { DateTimePicker as DTP, DateTimePickerProps } from "@mui/x-date-pickers";

type CustomDateTimePickerProps = DateTimePickerProps<Moment> & {
    viewOnly?: boolean,
    size?: "small" | "medium"
}

export const DATE_TIME_FORMAT = 'DD-MM-YYYY hh:mm A';

export const DateTimePicker: React.FC<CustomDateTimePickerProps> = ({ viewOnly = false, size = 'small', ...props }) => {

    const value: any = typeof props.value === "string" ? props.value || "N/A" : moment(props?.value)?.format(DATE_TIME_FORMAT);

    const sizeHeight = {
        'small': '40px',
        'medium': '56px'
    };

    const sizeTop = {
        'small': -7,
        'medium': 0
    };

    return (
        viewOnly ? (
            <Stack sx={{ overflowWrap: "break-word" }}>
                <Typography variant="body2" sx={{ fontFamily: "htrts_medium" }}>{props.label}</Typography>
                <Typography variant="body2" sx={{ fontFamily: "htrts_regular" }}>{value ? value : "-"}</Typography>
            </Stack>
        ) : <DTP
            {...props}
            sx={{
                width: "100%", '& .MuiInputBase-root': {
                    height: sizeHeight[size]
                },
                '& .MuiInputLabel-root': {
                    top: sizeTop[size]
                },
                '& .MuiInputLabel-shrink': {
                    top: 0
                },
                ...props.sx
            }}
        />

    )
};
